export type ClientObservedDurationBucket =
  | '<30s'
  | '30-120s'
  | '>120s'
  | 'unknown';

export type ClientObservedTerminalOutcome = 'completed' | 'failed' | 'expired';

/**
 * Client-observed elapsed time from a locally recorded invoke start.
 * `unknown` only when no trustworthy local start exists (resumed/pre-existing).
 */
export const bucketClientObservedDuration = (
  startedAt: number | null,
  now = Date.now(),
): ClientObservedDurationBucket => {
  if (startedAt === null) {
    return 'unknown';
  }
  const elapsedMs = now - startedAt;
  if (elapsedMs < 30_000) {
    return '<30s';
  }
  if (elapsedMs <= 120_000) {
    return '30-120s';
  }
  return '>120s';
};

export const toClientObservedTerminalOutcome = (
  status: string,
): ClientObservedTerminalOutcome | null => {
  if (status === 'completed' || status === 'failed' || status === 'expired') {
    return status;
  }
  return null;
};
